import { useEffect, useState } from "react";
import { ArrowPathIcon, AcademicCapIcon } from "@heroicons/react/24/outline";
import { getAllcourses } from "../../apis/CoursesApi";
import CourseCard from "./CourseCard";

const categories = [
  ["all", "All courses"],
  ["dsa", "Data structures & algorithms"],
  ["Backend", "Backend development"],
];

export default function CoursesPage() {
  const [courses, setCourses] = useState([]);
  const [category, setCategory] = useState("all");
  const [status, setStatus] = useState("loading");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setStatus("loading");
    getAllcourses(controller.signal)
      .then((data) => {
        if (!controller.signal.aborted) {
          setCourses(data);
          setStatus("ready");
        }
      })
      .catch(() => {
        if (!controller.signal.aborted) setStatus("error");
      });
    return () => controller.abort();
  }, [attempt]);
  const visible = courses.filter(
    (course) => category === "all" || course.cat === category,
  );

  return (
    <section className="page-width course-section" id="courses">
      <div className="section-heading">
        <div>
          <p className="eyebrow">FIND YOUR NEXT CHAPTER</p>
          <h2>
            A world of skills. <span>Yours to explore.</span>
          </h2>
          <p>Handpicked courses for wherever you want to go next.</p>
        </div>
        <span className="section-aside">
          <AcademicCapIcon /> Always free to learn
        </span>
      </div>
      <div className="filter-row" role="group" aria-label="Filter courses">
        {categories.map(([value, label]) => (
          <button
            key={value}
            className={
              category === value ? "filter-chip selected" : "filter-chip"
            }
            aria-pressed={category === value}
            onClick={() => setCategory(value)}
          >
            {label}
          </button>
        ))}
      </div>
      {status === "loading" ? (
        <div className="course-grid" role="status" aria-label="Loading courses">
          {[1, 2, 3].map((i) => (
            <div className="course-skeleton" key={i}>
              <div />
              <span />
              <span />
              <span />
            </div>
          ))}
        </div>
      ) : status === "error" ? (
        <div className="empty-state surface" role="alert">
          <AcademicCapIcon />
          <h3>Courses are taking a little longer.</h3>
          <p>We couldn’t reach the course library. Give it another try.</p>
          <button
            className="button button-secondary"
            onClick={() => setAttempt(attempt + 1)}
          >
            <ArrowPathIcon /> Try again
          </button>
        </div>
      ) : visible.length ? (
        <div className="course-grid">
          {visible.map((course) => (
            <CourseCard key={course._id || course.playlistID} course={course} />
          ))}
        </div>
      ) : (
        <div className="empty-state surface">
          <AcademicCapIcon />
          <h3>Something new is on the way.</h3>
          <p>No courses in this collection yet. Try another category.</p>
        </div>
      )}
    </section>
  );
}
